(function klaviyoBIS () {
  window.klaviyoBIS = klaviyoBIS

  const SIMULATE_SEND = false
  const selectors = {
    btn: document.querySelector('.product-form__buttons button'),
    outerBtn: document.querySelector('.product-form__buttons'),
    singleOptionSelector: document.querySelector('[data-single-option-selector]'),
    addBtns: document.querySelector('[data-add-to-cart]'),
    fakeButton: document.querySelector('[data-fake-button]'),
    soldOutBtns: 'data-sold-out',
    body: document.querySelector('body'),
    notifyModal: document.querySelector('#notify-me.modal'),
    notifyForm: document.querySelector('#notifyForm'),
    notifyFormMessage: document.querySelector('#form-messages'),
    successForm: document.querySelector('.notify-text'),
    notifyTextSuccess: document.querySelector('.notify-text-success'),
    submitBtn: document.querySelector('#notifyForm button'),
    formMessages: document.querySelector('#form-messages'),
    closeBtn: document.querySelector('#notify-me.modal button.js-modal-close'),
  }

  selectors.outerBtn?.addEventListener('click', handleAddBtnClick)
  selectors.notifyForm?.addEventListener('submit', formCheck)
  selectors.closeBtn?.addEventListener('click', closeModal)

  function klaviyoAtcEvent (productForm) {
    const itemData = {
      'Added to Cart Value': productForm.dataset.price,
      Name: productForm.dataset.name,
      ProductID: productForm.dataset.productId,
      Categories: productForm.dataset.categories,
      ImageURL: productForm.dataset.imageUrl,
      URL: productForm.dataset.url,
      Brand: productForm.dataset.brand,
      Price: productForm.dataset.price,
      CompareAtPrice: productForm.dataset.compareAtPrice,
    }
    const _learnq = window._learnq || []
    _learnq.push(['track', 'Added to Cart', itemData])
  }

  function handleAddBtnClick (e) {
    if (selectors.btn.dataset.notifyMe === 'true') {
      if (selectors.body.classList.contains('quickbuy-open')) {
        document.querySelector('quick-add-modal .product__view-details').click()
      } else {
        selectors.body.classList.toggle('is-modal-open')
        selectors.notifyModal.classList.toggle('hide')
        document.getElementById('full-name').focus()
      }
    } else {
      const productForm = e.currentTarget.closest('.main-product__form')
      if (productForm) klaviyoAtcEvent(productForm)
    }
  }

  function closeModal (e) {
    selectors.body.classList.toggle('is-modal-open')
    selectors.notifyModal.classList.toggle('hide')
  }

  function formCheck (e) {
    if (!selectors.notifyForm) {
      return
    }
  }

  function successPage () {
    selectors.successForm.classList.add('hide')
    selectors.notifyForm.classList.add('hide')
    selectors.notifyTextSuccess.classList.remove('hide')
    selectors.notifyTextSuccess.setAttribute('aria-hidden', false)
  }

  function errorPage () {
    selectors.notifyFormMessage.classList.remove('success')
    selectors.notifyFormMessage.classList.add('error')
  }

  function handleSuccessResponse (response) {
    selectors.submitBtn.disabled = false

    if (response.status === 'subscribed') {
      successPage()
    } else if (response.status === 400) {
      if (response.title === 'Member Exists') {
        successPage()
      } else {
        selectors.formMessages.innerText(`${response.title}: ${response.detail}`)
      }
    } else {
      let errorsHtml = '<ul>'
      response.error.forEach((key, value) => {
        errorsHtml += `<li>${value}</li>`
      })
      errorsHtml += '</ul>'
      selectors.formMessages.innerHTML = errorsHtml
      errorPage()
    }
  }

  function sendData (formData) {
    if (SIMULATE_SEND) {
      return
    }
    const email = formData.EMAIL
    if (!email) errorPage()

    const ids = getProductAndVariantId()
    const variant = ids.variantId
    // Handle Klaviyo request
    const ausAccount = 'WHZz9P'
    const rowAccount = 'VPQciy'
    let a = ausAccount
    if (Shopify.shop === 'triangl-america.myshopify.com') a = rowAccount

    fetch('https://triangl.netlify.app/.netlify/functions/index', {
      method: 'POST',
      body: JSON.stringify({
        a: a,
        email: email,
        variant: variant,
        platform: 'shopify',
      }),
      headers: {
        accept: 'application/json',
      },
    }).then((response) => {
      // temporary fix until the API is updated
      if (response.status === 200) {
        handleSuccessResponse({ status: 'subscribed' })
      }
      return response.json()
    }).then((result) => {
      if (result.success === true) {
        handleSuccessResponse({ status: 'subscribed' })
      }
    }).catch((error) => {
      errorPage()
      console.error(error)
    })
  }

  function getProductAndVariantId () {
    const productForm = document.querySelector('product-form')
    const productIdValue = productForm.dataset.productId
    const variantIdValue = new FormData(productForm.querySelector('form')).get('id')
    const variantTopIdValue = new FormData(productForm.querySelector('form')).get('top-id')
    let variantId = variantIdValue

    // this is a set
    if (!variantIdValue) {
      [...document.querySelectorAll('set-variant-radios')].every(e => {
        if (!e.currentVariant.available) {
          x = e.currentVariant.id
          return false
        } else {
          return true
        }
      })
    }

    return {
      productId: productIdValue,
      variantId: variantIdValue ? variantIdValue : variantTopIdValue
    }
  }

  function handleFormSubmit (event) {
    event.preventDefault()

    selectors.submitBtn.disabled = true
    selectors.formMessages.innerHTML = ''

    const email = document.querySelector('#email-address').value
    const fullName = document.querySelector('#full-name').value
    const listID = '889f61c5fd'

    const store = window.theme.permanentDomain
    const storePrefix = `${store.slice(0, store.indexOf('.'))}_`

    // Get the products to add to the notify me list
    const variantSelectors = document.querySelectorAll('[data-addon-select], [data-bottom-select], [data-product-select]')
    const unavailableSkus = []
    let unavailableStr = ','

    for (let s = 0; s < variantSelectors.length; s++) {
      const $selection = variantSelectors[s].closest(':selected')
      const isUnavailable = $selection.dataset.available === 'false'
      const selectionSku = $selection.dataset.dataSku
      if (isUnavailable && selectionSku) {
        unavailableSkus.push(selectionSku)
      }
    }

    for (let u = 0; u < unavailableSkus.length; u++) {
      unavailableStr += `${storePrefix}${unavailableSkus[u]},`
    }

    const formData = {
      EMAIL: email,
      FNAME: fullName,
      LIST: listID,
      PRODUCTS: unavailableStr,
    }

    sendData(formData)
  }

  selectors.notifyForm?.addEventListener('submit', handleFormSubmit)
})()
